<template>
<div>
  <div class="sub-header-container">
    <div class="sub-header-content" style="justify-content: center;">
      <div class="page-title-container" style="padding-top:40px; padding-bottom: 40px;">
        <div class="page-title" style="text-align: center;">Sign up and drive traffic to your Twitter threads 🧵</div>
      </div>
    </div>
  </div>

  <div class="page-container">
    <Register @registered="$router.push({ path: '/' })"/>
  </div>
</div>

</template>

<script>
import * as validator from 'email-validator'
import firebase from '@/firebase'
import Register from '@/components/Register'

export default {
  name: 'RegisterView',

  components: {
    Register,
  },

  data() {
    return {
      showEmailBadFormat: false,
      showMissingError: false,
      showLoginError: false,
      email: '',
      password: '',
    }
  },

  methods: {
    select(ref, model){
      ref.focus()
      ref.setSelectionRange(0, model.length)
    },

    register() {
      this.showEmailBadFormat = false
      this.showMissingError = false
      this.showLoginError = false

      if(!validator.validate(this.email)){
        this.showEmailBadFormat = true
        this.select(this.$refs.email, this.email)
        this.password = ''
      }

      if(this.email == null || this.email == '') {
        this.showMissingError = true
        this.select(this.$refs.email, this.email)
        this.password = ''
      }

      if(this.password == null || this.password == '') {
        this.showMissingError = true
        this.select(this.$refs.password, this.password)
        this.password = ''
      }

      if(this.showEmailBadFormat || this.showMissingError){
        return
      }

      firebase.auth
        .createUserWithEmailAndPassword(this.email, this.password)
          .then(function() {
            firebase.analytics.logEvent('sign_up', { method: 'emailAndPassword' })
            this.$emit('registered')
          })
          .catch(function() {
            this.showLoginError = true
            this.select(this.$refs.email, this.email)
            this.password = ''
          })
    },
  },
}
</script>

<style scoped>
.p-error {
  color: red;
}
.header-container{
  background-color: var(--global-header-color);
  max-width: 1100px;
  padding: 10px 3rem 10px 3rem;
  margin: 0 auto;
}
.sub-header-container{
  background-color: transparent;
  max-width: 1100px;
  padding: 0 3rem;
  margin: 0 auto 10px auto;
}
.page-container{
  max-width: 1100px;
  padding: 0 3rem;
  margin: 0 auto;
}
@media (max-width: 760px){
  .header-container{
  padding: 0 0.5rem;
  }
  .sub-header-container{
  padding: 0 0.5rem;
  }
  .page-container{
  padding: 0 0.5rem;
  }
  .website-name{
    font-size: 15px;
  }
   .website-name-container img{
    width: 22px;
  }
  .website-name-container p{
    display: none;
  }
}
</style>
